import { Link } from "~/components/Link";
import { cn } from "~/lib/utils";
import { CatalogUserEvents } from "~/modules/analytics/events/catalog";
import { MAP_COLOR_TO_SOLID_BG_CLASS_NAME } from "~/modules/catalog/consts";
import { CatalogIcon } from "../../components/CatalogIcon";
import { getCatalogCoveragePercent } from "../../lib/getCatalogCoveragePercent";

// // // //

export function FeaturedCard({
    label,
    slug,
    description,
    href,
    icon,
    color,
    assetCount,
    totalAssetCount,
}: {
    label: string;
    slug: string;
    description?: string | null;
    href: string;
    icon: string;
    color: string;
    assetCount: number;
    totalAssetCount: number;
}) {
    const solidBgClass =
        MAP_COLOR_TO_SOLID_BG_CLASS_NAME[
            color as keyof typeof MAP_COLOR_TO_SOLID_BG_CLASS_NAME
        ] ?? "bg-primary";

    const coveragePct = getCatalogCoveragePercent({
        totalAssetCount,
        assetCount,
    });

    return (
        <Link
            href={href}
            analyticsLabel={CatalogUserEvents.ClickFeaturedCard}
            analyticsEventProperties={{ slug }}
            className={cn(
                "group flex flex-col justify-between",
                "rounded-xl p-4",
                "bg-card border",
                "transition-all duration-200",
                "hover:bg-background-hover",
            )}
        >
            <div>
                <CatalogIcon
                    icon={icon}
                    color={color}
                    size="md"
                    className="mb-3"
                />
                <h3 className="text-sm font-semibold text-foreground leading-snug truncate">
                    {label}
                </h3>
                <p className="mt-1 text-xs text-slate-500 leading-relaxed line-clamp-2">
                    {description}
                </p>
            </div>
            <div className="mt-3">
                <div className="flex items-baseline justify-between">
                    <span className="text-sm font-light text-muted-foreground tabular-nums">
                        {assetCount.toLocaleString()} Assets
                    </span>
                    <span className="text-xs text-muted-foreground tabular-nums">
                        {coveragePct}
                    </span>
                </div>
                <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-muted">
                    <div
                        className={cn("h-full rounded-full", solidBgClass)}
                        style={{ width: `${coveragePct}` }}
                    />
                </div>
            </div>
        </Link>
    );
}
